/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'play': {
    width: 25,
    height: 25,
    viewBox: '0 0 1024 1024',
    data: '<path pid="0" d="M423.688 757.479a100.196 100.196 0 01-100.196-101.198V366.716a100.196 100.196 0 01153.3-85.166l232.453 145.283a100.196 100.196 0 010 170.333L476.792 741.448a100.196 100.196 0 01-52.102 15.029zm0-410.802a21.041 21.041 0 00-10.02 3.006 20.04 20.04 0 00-10.02 17.033v289.565a20.04 20.04 0 0031.061 17.034L667.163 528.03a20.04 20.04 0 000-34.067L433.708 349.683a19.037 19.037 0 00-10.02-4.008z" _fill="#fff"/><path pid="1" d="M512.862 1024a512 512 0 01-199.39-983.922 512 512 0 01398.78 942.841 508.994 508.994 0 01-199.39 41.08zm0-943.843C274.396 80.157 81.02 273.534 81.02 512s193.377 431.843 431.843 431.843S944.705 749.463 944.705 512 750.325 80.157 512.862 80.157z" _fill="#fff"/>'
  }
})
